import { SeenTracker, Subject } from '~/rage/utils';
import {
	ProductShopItemCategory,
	ProductShopItemConfig,
	ProductShopType,
	WalletType,
} from '~/shared';
import { IProductShopService } from './productShopServiceTypes';

export class ProductShopServiceStub implements IProductShopService {
	private seenTracker = new SeenTracker(null);
	private productShopType = new Subject<ProductShopType>(
		ProductShopType.EVERYDAY,
	);

	private readonly items = new Subject<ProductShopItemConfig[]>([
		{
			id: 'hamburger',
			name: 'Бургер',
			price: 100,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'cheeseburger',
			name: 'Чизбургер',
			price: 200,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'baconizer',
			name: 'Беконайзер',
			price: 300,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'fries',
			name: 'Картофель фри',
			price: 400,
			walletType: WalletType.Donate,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'sandwich',
			name: 'Сендвич',
			price: 100,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'hotdog',
			name: 'Хот-дог',
			price: 100,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.FOOD,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'rod1',
			name: 'Удочка 1',
			price: 100,
			walletType: WalletType.Cash,
			category: ProductShopItemCategory.ITEMS,
			type: ProductShopType.EVERYDAY,
		},
		{
			id: 'rod2',
			name: 'Удочка 2',
			price: 100,
			walletType: WalletType.Donate,
			category: ProductShopItemCategory.ITEMS,
			type: ProductShopType.EVERYDAY,
		},
	]);

	public getProductShopType(): Subject<ProductShopType> {
		return this.productShopType;
	}

	public getItems(): Subject<ProductShopItemConfig[]> {
		return this.items;
	}

	public async buy(
		itemId: string,
		count: number,
		walletType: WalletType,
	): Promise<void> {
		console.log('productShop:buy', itemId, count, walletType);
	}

	isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	markSeen(path: string): void {
		console.log('productShop:markSeen', path);
		this.seenTracker.markAsSeen(path);
	}

	public async exitMenu(): Promise<void> {
		console.log('productShop:exitMenu');
	}
}
